var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "sections" },
      [
        _c(
          "section",
          [
            _vm.firstLabel
              ? _c("h3", [_vm._v("Ist Homeoffice vorgesehen?")])
              : _vm._e(),
            _vm._v(" "),
            _c("RadioGroup", {
              attrs: { options: _vm.typeOptions, stacked: "" },
              on: { input: _vm.emitChangeEvent },
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.startEligible
          ? _c(
              "section",
              [
                _c("h3", [_vm._v("Ab wann ist Homeoffice möglich?")]),
                _vm._v(" "),
                _c("b-form-checkbox-group", {
                  attrs: { options: _vm.startOptions },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.start,
                    callback: function($$v) {
                      _vm.start = $$v
                    },
                    expression: "start"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.degreeEligible
          ? [
              _c(
                "section",
                [
                  _c("h3", [_vm._v("In welchem Ausmaß?")]),
                  _vm._v(" "),
                  _c("RadioGroup", {
                    attrs: { options: _vm.degreeOptions },
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.degree,
                      callback: function($$v) {
                        _vm.degree = $$v
                      },
                      expression: "degree"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.degreeDaysEligible
                ? _c(
                    "section",
                    [
                      _c("h3", [_vm._v("Tage pro Woche")]),
                      _vm._v(" "),
                      _c("RadioGroup", {
                        attrs: { options: _vm.degreeDaysOptions, stacked: "" },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.degreeDays,
                          callback: function($$v) {
                            _vm.degreeDays = $$v
                          },
                          expression: "degreeDays"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }